import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/incomingMails/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'

const defaultCardState = {
  isLoading: false,
  isLoaded: false
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ cardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      cardId,
      isLoading,
      isLoaded
    }
  }
}
